module.exports = __webpack_public_path__ + "static/konnectzit-7a1441a09526d05998269dcd90eab11b.svg";